export default "__VITE_ASSET__Dmf7ARzb__"